import { render, staticRenderFns } from "./CobManageCustomer.vue?vue&type=template&id=b6d9c18a&"
import script from "./CobManageCustomer.vue?vue&type=script&lang=js&"
export * from "./CobManageCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CobManageCustomer.vue?vue&type=style&index=0&id=b6d9c18a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports